import Banner from '../../components/banner/Banner.tsx'
import ServiceList from '../../components/service/servicesList/ServiceList.tsx'
import { Helmet } from "react-helmet-async";


const Portfolio = () => {
  return (
    <div>
       {/* SEO */}
      <Helmet>
        <title>Nos services - VRN Innovation</title>
        <meta
          name="description"
          content="Découvrez tous les services de VRN Innovation : développement web et mobile, hébergement, installation Starlink, réseaux, sécurité, domotique, marketing digital, formations et consulting IT."
        />
        <meta
          name="keywords"
          content="Développement web, Développement mobile, Hébergement, Starlink, Réseau, Caméras, Domotique, Marketing digital, Formation, Consulting IT, Douala Cameroun"
        />
        <link rel="canonical" href="https://www.vrn-innovation.com/portfolio" />
      </Helmet>
      <Banner
        title="Services"
        breadcrumbs={[
          { label: "Accueil", link: "/" },
          { label: "Services" },
        ]}
      />
      <ServiceList />
    </div>
  )
}

export default Portfolio
